export const UserType = [
  { value: "SA", text: "Super admin" },
  { value: "B", text: "BILLER" },
  { value: "WM", text: "Warehouse Manager" },
  { value: "SM", text: "Store Manager" },
  { value: "PO", text: "Property Owner" },
  { value: "BO", text: "Brand Owner" },
  { value: "CM", text: "Cluster Manager" },
  { value: "CAM", text: "Catalog Manager" },
  { value: "AM", text: "Accounts Manager" },
  { value: "OM", text: "Opration Manager" },
  { value: "R", text: "Runner" },
  // Business Partner (BP) was merged into Property Owner — create a PO instead.
  { value: "C", text: "" },
];

export const UserTypeObj = {
  SA: "SA",
  B: "B",
  WM: "WM",
  SM: "SM",
  PO: "PO",
  BO: "BO",
  CM: "CM",
  CAM: "CAM",
  AM: "AM",
  OM: "OM",
  R: "R",
  C: "C",
};

// User types that sign in to the Operations Portal
// (Property Owner replaces the old Business Partner role.)
export const OperationsPortalUserTypes = ["PO", "CM"];

/****User Permission */
export const userRelated = ["SA", "AM"];
export const storeRelated = ["SA", "OM", "PO", "BO", "B"];
export const storeStockRelated = ["SA", "OM", "SM", "PO", "BO", "B"];
export const stockTransferRelated = ["SA", "OM", "WM", "SM", "B"];
export const warehouseRelated = ["SA", "OM", "WM"];
export const warehouseStockRelated = ["SA", "OM", "WM", "BO"];
export const warehouseTransferRelated = ["SA", "OM", "WM"];
export const productRelated = ["SA", "SM", "CA"];
export const userSpecificPermissions = ["953"];

export const B2BUserAccess = [
  // "mani",
  // "accounts1",
  // "accounts2",
  // "category1",
  "category2",
  "category3",
  "category4",
];
